import SectionAlarmsProvider from '@/providers/SectionAlarmsProvider'

class SectionAlarmsService {
  async getAlarmSettings (token, objectId) {
    return SectionAlarmsProvider.getAlarmSettings(token, objectId)
  }

  async updateAlarmSettings (token, objectId, alarmSetting) {
    return SectionAlarmsProvider.updateAlarmSettings(token, objectId, alarmSetting)
  }

  async saveAlarmSettings (token, objectId, alarmSetting) {
    return SectionAlarmsProvider.saveAlarmSettings(token, objectId, alarmSetting)
  }

  async getAlarmResults (token, objectId, dtFrom, dtTo) {
    return SectionAlarmsProvider.getAlarmResults(token, objectId, dtFrom, dtTo)
  }
}

export default new SectionAlarmsService()



// WEBPACK FOOTER //
// ./src/services/r8/SectionAlarmService.js